<template>
  <el-dialog :visible.sync="visible"
             :title="title"
             center
             width="600px">
    <el-form :model="ruleForm"
             status-icon
             :rules="rules"
             ref="ruleForm"
             label-width="140px">
      <el-form-item label="请输入新手机号："
                    prop="phone">
        <el-input v-model="ruleForm.phone">
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="sendCode" :disabled="smsFlag" type="primary" >{{sendTime}}</el-button>
      </el-form-item>
      <el-form-item label="请输入验证码："
                    prop="code">
        <el-input v-model="ruleForm.code">
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button type="primary"
                 @click="submitForm('ruleForm')">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getInfo, updateBindPhone } from '@/api/login'
import {sendSms} from '@/api/sms'
export default {
  neme: 'ChangeTel',
  data () {
    var checkTel = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'))
      } else {
        const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确手机号'))
        }
      }
    }
    return {
      visible: false,
      title: null,
      loading: false,
      model: null,
      snsMsgWait: 60,
      smsFlag: false,
      sendTime: '获取验证码',
      ruleForm: {
        phone: '',
        code: ''
      },
      userData: {},
      rules: {
        phone: [
          { type: 'number', required: true, validator: checkTel, trigger: 'blur' }
        ],
        code: [
          { required: true, message: '验证码不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    detail () {
      this.visible = true
      this.title = '更换绑定手机号码'
      this.getUserInfo()
    },
    getUserInfo () {
      getInfo().then(res => {
        this.ruleForm.userId = res.data.userId
      })
    },
    // 获取验证码
    sendCode: function () {
      if (this.ruleForm.phone === '') {
        this.$message.info('手机号码不能为空')
        return
      }
      if (!(/^1[345789]\d{9}$/).test(this.ruleForm.phone)) {
        this.$message.info('手机号码格式错误')
        return
      }
      var params = {
        phone: this.ruleForm.phone
      }
      sendSms(params).then(res => {
        this.$message.success('短信发送成功')
        this.countDown()
      })
    },
    countDown() {
      // 60秒后重新获取验证码
      var inter = setInterval(function () {
        this.smsFlag = true
        this.sendColor = '#cccccc'
        this.sendTime = this.snsMsgWait + 's后可重发'
        this.snsMsgWait = this.snsMsgWait - 1
        if (this.snsMsgWait < 0) {
          clearInterval(inter)
          this.smsFlag = false
          this.sendColor = '#EF6C00'
          this.sendTime = '获取验证码'
          this.snsMsgWait = 60
        }
      }.bind(this), 1000)
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          updateBindPhone(this.ruleForm).then(res => {
            this.visible = false
            this.$message({
              type: 'success',
              message: '修改成功，请重新登录！'
            })
            this.$store.dispatch('LogOut').then(() => {
              location.reload()
            })
          })
        }
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/sys/ChangeTel.vue